<div *ngIf="registration != undefined" class="a-logo">
  <i class="webfont webfont-ticket"></i>
  <p >{{ registration ? ("Inscription" | customTranslation:"registration" ): ("Billetterie" | customTranslation:"ticketing" )}}</p>
</div>
